var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-1"},[_c('v-card-title',[_vm._v("Promo kódy")]),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data},scopedSlots:_vm._u([{key:"item.totalSales",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.totalSales)+" Kč ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }